module.exports = __webpack_public_path__ + "30bbf9ede3b3db0ab74a12cf22f77fa3.MP3";